import PropTypes from "prop-types";

export const deviceInfoProviderPropTypes = {
  /** Content that will be rendered with context. */
  children: PropTypes.node,

  /** Whether to allow the user's system setting dark mode preference. */
  darkModeEnabled: PropTypes.bool,
};
